<template>
    <div>
        <menu-bar></menu-bar>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a :href="'#/'"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a :href="'#/smtps'"><i class="fa fa-envelope-o" aria-hidden="true"></i> SMTP</a></li>
                    <li class="active">CADASTRO DE SMTPS</li>
                </ol>

                <div class="col-md-3">
                    <smtp-menu :smtp_id="smtp_id"></smtp-menu>
                </div>

                <div class="col-md-9" v-if="smtp">
                    <router-view></router-view>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import pontoMixin from "../../mixins/smtp";
import pontoComputedMixin from "../../mixins/smtp_computed";
import { SmtpMenu } from "../../../components/exports";
export default {
    mixins: [pontoMixin, pontoComputedMixin],
    components: {
        SmtpMenu
    }
};
</script>
